import { format, parse, isValid } from "date-fns";

/**
 * Generate a path-based URL for the time slots results page.
 * Format: /slobodni-termini/DD-MM-YYYY/HH-MM
 */
export function getTimeSlotsUrl(
  date: Date,
  sessionType?: "INDIVIDUAL" | "COUPLES",
): string {
  const dateSlug = format(date, "dd-MM-yyyy");
  const timeSlug = format(date, "HH-mm");
  const path = `/slobodni-termini/${dateSlug}/${timeSlug}`;
  return sessionType === "COUPLES" ? `${path}?sessionType=COUPLES` : path;
}

/**
 * Parse route params back to a Date.
 * Returns null if the params are invalid.
 */
export function parseTimeSlotsParams(
  dateSlug: string,
  timeSlug: string,
): Date | null {
  const combined = `${dateSlug} ${timeSlug}`;
  const parsed = parse(combined, "dd-MM-yyyy HH-mm", new Date());
  if (!isValid(parsed)) return null;
  return parsed;
}
